module.exports = __webpack_public_path__ + "static/media/christine-prof.9b57812f.svg";